




























import * as Util from '@/util.ts';
import Vue from 'vue';

export default Vue.extend({
});
